
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 42 42","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M0 .875v40.25c0 .525.35.875.875.875H32.55c.525 0 .875-.35.875-.875V37.45l2.363 2.888c1.225 1.487 3.325 1.662 4.725.525 1.4-1.138 1.662-3.325.525-4.725l-4.813-5.95c.612-1.138 1.05-2.363 1.225-3.675.35-3.5-1.313-6.738-3.937-8.663V9.8c0-.175-.175-.525-.35-.7L22.838.262C22.75.175 22.487 0 22.224 0H.875A.877.877 0 000 .875zM39.725 37.1c.613.7.438 1.75-.262 2.275-.7.613-1.75.438-2.275-.262L32.725 33.6a8.357 8.357 0 002.538-2.1l4.462 5.6zM35.7 26.25c-.437 4.2-4.112 7.263-8.4 6.825-4.2-.438-7.262-4.2-6.825-8.4.438-4.2 4.113-7.263 8.4-6.825 4.2.438 7.263 4.2 6.825 8.4zM23.1 2.8l7.175 6.038H23.1V2.8zM1.75 1.75h19.6v7.963c0 .525.35.875.875.875h9.538V16.8a8.956 8.956 0 00-2.625-.7c-3.675-.35-7 1.4-8.838 4.287H7.526c-.525 0-.875.35-.875.875s.35.875.875.875h11.813a9.37 9.37 0 00-.525 2.363c0 .437-.088.875 0 1.225H7.526c-.525 0-.875.35-.875.875s.35.875.875.875h11.462c.875 3.85 4.113 6.825 8.226 7.262 1.312.175 2.625 0 3.85-.437l.7.875v5.075H1.75V1.75z","fill":"#218665"}}),_c('path',{attrs:{"d":"M7.526 16.8h13.038c.525 0 .875-.35.875-.874 0-.525-.35-.875-.875-.875H7.526c-.525 0-.875.35-.875.875s.35.875.875.875zM23.887 20.3c-1.4 1.138-2.187 2.713-2.45 4.463-.087.437.263.875.788.962.524 0 .875-.35.962-.787a5.393 5.393 0 011.75-3.325c.35-.262.438-.875.088-1.225-.175-.35-.7-.35-1.138-.088z","fill":"#218665"}})])
          )
        }
      }
    